import Icon from '../components/Icon.vue'

Icon.register({
  chair: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M112 128v128h-48v-128c0-70.7 57.3-128 128-128h64c70.7 0 128 57.3 128 128v128h-48v-128c0-29.5-16.2-55-40-68.9v196.9h-48v-208h-48v208h-48v-196.9c-23.8 13.9-40 39.4-40 68.9zM446.3 341.9c6.9 20.7-8.5 42.1-30.3 42.1v112c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-112h-256v112c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-112c-21.8 0-37.2-21.4-30.4-42.1l10.7-32c4.4-13.1 16.6-21.9 30.4-21.9h362.5c13.8 0 26 8.8 30.4 21.9z'
      }
    ]
  }
})
